export enum CracMapStatus {
    WAITING = 1,
    PROCESSING = 2,
    AVAILABLE = 3,
}

export const CRACMAP_STATUS_CONSTANTS = [
    {
        label: 'En attente de vos données',
        value: CracMapStatus.WAITING,
    },
    {
        label: 'Traitement en cours',
        value: CracMapStatus.PROCESSING,
    },
    {
        label: 'Disponible',
        value: CracMapStatus.AVAILABLE,
    },
];

export const CRACMAP_CONSTANTS = {
    title: 'Cartes nationales des principaux indicateurs issus des CRAC',
    subTitle: 'Sélectionner un indicateur et comparer les concessions',
    explanationText:
        'Les cercles représentent les résultats sur la commune principale de chaque Métropole ou Communauté Urbaine. Les zones transparentes correspondent aux territoires non distribués par Enedis ou EDF SEI.',
    callToActionText:
        'Il est possible que des approximations soient visibles à propos des contours des territoires concédés du fait de notre connaissance imparfaite de la totalité des périmètres des concessions et des ELD. \nNous restons bien entendu à votre disposition pour recueillir vos remarques et effectuer des ajustements',
    centerLyon: { lat: 45.75, lon: 4.85, zoomLevel: 9 },
    centerParis: { lat: 48.866667, lon: 2.333333, zoomLevel: 9 },
    indicators: [
        {
            value: 'critbHix',
            label: 'Le critère B HIX - année n',
            unit: 'min.',
            legendConfig: [
                { color: '#1a9641', value: '0-30 min.', min: 0, max: 30 },
                { color: '#8acc62', value: '30-60 min.', min: 30, max: 60 },
                { color: '#dcf09e', value: '60-90 min.', min: 60, max: 90 },
                { color: '#ffdf9a', value: '90-120 min.', min: 90, max: 120 },
                { color: '#f69053', value: '120-150 min.', min: 120, max: 150 },
                { color: '#d7191c', value: '> 150 min.', min: 150, max: 1000 },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'critbTcc',
            label: 'Le critère B TCC - année n',
            unit: 'min.',
            legendConfig: [
                { color: '#1a9641', value: '0-30 min.', min: 0, max: 30 },
                { color: '#8acc62', value: '30-60 min.', min: 30, max: 60 },
                { color: '#dcf09e', value: '60-90 min.', min: 60, max: 90 },
                { color: '#ffdf9a', value: '90-120 min.', min: 90, max: 120 },
                { color: '#f69053', value: '120-150 min.', min: 120, max: 150 },
                { color: '#d7191c', value: '> 150 min.', min: 150, max: 1000 },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'critbHixMaNN1',
            label: 'Le critère B HIX - moyenne n à n-1',
            unit: 'min.',
            legendConfig: [
                { color: '#1a9641', value: '0-30 min.', min: 0, max: 30 },
                { color: '#8acc62', value: '30-60 min.', min: 30, max: 60 },
                { color: '#dcf09e', value: '60-90 min.', min: 60, max: 90 },
                { color: '#ffdf9a', value: '90-120 min.', min: 90, max: 120 },
                { color: '#f69053', value: '120-150 min.', min: 120, max: 150 },
                { color: '#d7191c', value: '> 150 min.', min: 150, max: 1000 },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'critbHixMaNN1N2',
            label: 'Le critère B HIX - moyenne n à n-2',
            unit: 'min.',
            legendConfig: [
                { color: '#1a9641', value: '0-30 min.', min: 0, max: 30 },
                { color: '#8acc62', value: '30-60 min.', min: 30, max: 60 },
                { color: '#dcf09e', value: '60-90 min.', min: 60, max: 90 },
                { color: '#ffdf9a', value: '90-120 min.', min: 90, max: 120 },
                { color: '#f69053', value: '120-150 min.', min: 120, max: 150 },
                { color: '#d7191c', value: '> 150 min.', min: 150, max: 1000 },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'txCma',
            label: 'Taux de Clients BT considérés Mal Alimentés',
            unit: '%',
            legendConfig: [
                { color: '#1a9641', value: '< 0,25 %', min: -Infinity, max: 0.0025 },
                { color: '#8acc62', value: '0,25-0,5 %', min: 0.0025, max: 0.005 },
                { color: '#dcf09e', value: '0,5-1,0 %', min: 0.005, max: 0.01 },
                { color: '#ffdf9a', value: '1,0-1,5 %', min: 0.01, max: 0.015 },
                { color: '#f69053', value: '1,5-2,0 %', min: 0.015, max: 0.02 },
                { color: '#d7191c', value: '>2,0 %', min: 0.02, max: Infinity },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'tauxReclaEnedis',
            label: 'Ratio de réclamations (orales et écrites) traitées par Enedis pour 10 000 usagers - année n',
            unit: 'réclamations',
            legendConfig: [
                { color: '#1a9641', value: '0-50 réclam.', min: 0, max: 50 },
                { color: '#8acc62', value: '50-60 réclam.', min: 50, max: 60 },
                { color: '#dcf09e', value: '60-70 réclam.', min: 60, max: 70 },
                { color: '#ffdf9a', value: '70-80 réclam.', min: 70, max: 80 },
                { color: '#f69053', value: '80-90 réclam.', min: 80, max: 90 },
                { color: '#d7191c', value: '> 90 réclam.', min: 90, max: +Infinity },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'tauxReclaEdf',
            label: 'Ratio de réclamations (écrites) traitées par EDF pour 10 000 clients aux tarifs bleus - année n',
            unit: 'réclamations',
            legendConfig: [
                { color: '#1a9641', value: '0-260 réclam.', min: 0, max: 260 },
                { color: '#8acc62', value: '260-280 réclam.', min: 260, max: 280 },
                { color: '#dcf09e', value: '280-300 réclam.', min: 280, max: 300 },
                { color: '#ffdf9a', value: '300-320 réclam.', min: 300, max: 320 },
                { color: '#f69053', value: '320-340 réclam.', min: 320, max: 340 },
                { color: '#d7191c', value: '> 340 réclam.', min: 340, max: +Infinity },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
        {
            value: 'densiteUsagerAuKm',
            label: 'Densité d’usagers (nombre d’usagers par km de réseaux, HTA et BT confondus) - année n',
            unit: 'usagers/km',
            legendConfig: [
                { color: '#1a9641', value: '0-10 usagers/km', min: 0, max: 10 },
                { color: '#8acc62', value: '10-20 usagers/km', min: 10, max: 20 },
                { color: '#dcf09e', value: '20-30 usagers/km', min: 20, max: 40 },
                { color: '#ffdf9a', value: '30-40 usagers/km', min: 30, max: 40 },
                { color: '#f69053', value: '40-50 usagers/km', min: 40, max: 50 },
                { color: '#d7191c', value: '>50 usagers/km', min: 50, max: Infinity },
                { color: '#d4d4d4', value: 'Indisponible', min: -Infinity, max: Infinity },
            ],
        },
    ],
};
